import React from "react";
import { Modal } from "@linkfluence/core/modal";
import { Locale } from "@linkfluence/models/locale";
import Form, { Fieldset } from "@ui-kit/form";
import Textarea from "@ui-kit/form/textarea";
import ModalContent from "@ui-kit/modal";
import { tr } from "@radarly/i18n";

export default function useEditIpAIContextModal(
  locale: Locale,
  setLocalToAIContext: () => void
) {
  const { open, close, ModalWrapper } = Modal.get(
    "modal_descripton_IP_card_edition"
  );

  const onOpenEditAIContextModal = () => {
    open();
  };

  const onCancelEditIpDescriptionModal = () => {
    setLocalToAIContext();
    close();
  };

  const EditIpAIContext = (
    context: string,
    setAIContext: (value: string) => void
  ) => (
    <ModalWrapper>
      <ModalContent
        title={tr(
          locale,
          `CUSTOM_PAGES::EDITOR::DATAVIZ::MODAL_IP_DESCRIPTION::TITLE`
        )}
        description={tr(
          locale,
          `CUSTOM_PAGES::EDITOR::DATAVIZ::MODAL_IP_DESCRIPTION::DESCRIPTION`
        )}
        onCancel={() => onCancelEditIpDescriptionModal()}
        cancelLabel={tr(locale, "MODAL::CLOSE")}
        locale={locale}
        width="auto"
      >
        <Form>
          <Fieldset>
            <Textarea
              content={context}
              onChange={(e) => setAIContext(e)}
              placeholder={tr(
                locale,
                "CUSTOM_PAGES::EDITOR::DATAVIZ::MODAL_IP_DESCRIPTION::PLACEHOLDER"
              )}
              variant="primary"
              minHeight={120}
            />
          </Fieldset>
        </Form>
      </ModalContent>
    </ModalWrapper>
  );
  return {
    EditIpAIContext,
    onOpenEditAIContextModal,
  };
}
